import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { css, TooltipHost, TooltipOverflowMode, mergeStyleSets } from '@fluentui/react';
import { __Consolidation } from '../../../../../../common/Dictionaries';
import JqxProgressBar from 'jqwidgets-scripts/jqwidgets-react-tsx/jqxprogressbar';
import { Col } from 'react-bootstrap';
import i18next from 'i18next';

function ItemGroup(props) {
  	const { t } = useTranslation();

    //Parametros de entrada.
    const { 
        inputParam_Object = null,
    } = props;

    const classNames = mergeStyleSets({
        overflow: {
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        },
    });

    return (
        <>
            <div className='mx-0 px-0 my-auto' style={{width: "33%"}}>
                <div className='my-1 ps-0 pe-1 my-0 text-start'>
                    <TooltipHost
                        overflowMode={TooltipOverflowMode.Self}
                        hostClassName={css(classNames.overflow)}
                        content={ inputParam_Object.variableName }
                        onTooltipToggle={false}
                        styles={{
                            root: { display: 'block', height: "33px", position: "relative" },
                        }}
                    >
                        <div style={{fontSize: "15px", position: "absolute", top: "50%", transform: "translateY(-50%)", height: (inputParam_Object.variableName.length <= 44 ? "auto" : "33px")}}>
                            <b>{`${inputParam_Object.variableName}`}</b>
                        </div>
                    </TooltipHost> 
                </div>
            </div>
            <div className='mx-0 px-0' style={{width: "67%"}}>
                <div className='d-flex border-end border-top border-bottom'>
                    <div className='px-0 my-auto' style={{width: "37%"}}>
                        <div style={{width: "100%"}}>
                            <TooltipHost content={inputParam_Object.l_vals.length > 0 ? (inputParam_Object.l_vals[0].v1 !== undefined && inputParam_Object.l_vals[0].v1 !== null ? inputParam_Object.l_vals[0].v1 : t('no-data')) : t('no-data') } >
                                <div value-id={inputParam_Object.l_vals.length > 0 ? inputParam_Object.l_vals[0].id : 0} className={`cursor-pointer my-1 px-0 text-start`}>
                                    {`${inputParam_Object.l_vals.length > 0 ? (inputParam_Object.l_vals[0].v1 !== undefined && inputParam_Object.l_vals[0].v1 !== null ? `${parseFloat(inputParam_Object.l_vals[0].v1.toFixed(2)).toLocaleString(i18next.language)}${inputParam_Object.um}` : t('no-data')) : t('no-data')}`}
                                </div>
                            </TooltipHost>
                        </div>
                    </div>
                    <div className='px-0 my-auto' style={{width: "63%"}}>
                        <div style={{width: "100%"}}>
                                <div value-id={inputParam_Object.id} className={`cursor-pointer my-1 px-0 mx-0`}>                                   
                                    <JqxProgressBar width={'100%'} height={30} value={inputParam_Object.l_vals.length > 0 ? inputParam_Object.l_vals[0].v1 : 0} className={`custom-progressbar-on`} />
                                </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

ItemGroup.propTypes = {
    inputParam_Object: PropTypes.object.isRequired,
};

export default ItemGroup;